import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ConfigService } from 'app/shared/config/config.service';
import { FEEDBACK_REVIEW_SESSION_KEY } from 'app/shared/constants/local-storage.constants';
import { first } from 'rxjs';

@Component({
  selector: 'app-feedback-review',
  templateUrl: './feedback-review.component.html',
  styleUrls: ['./feedback-review.component.scss'],
})
export class FeedbackReviewComponent implements OnInit {
  public rating = 0;
  public comment = '';
  public visible = false;
  public thankYouVisible = false;
  public appName: string;

  private readonly FEEDBACK_REVIEW_COOLDOWN_MONTHS = 3;

  constructor(private http: HttpClient, private configService: ConfigService) {}

  public ngOnInit(): void {
    this.visible = this.shouldShowDialog();

    const config = this.configService.getConfig();
    this.appName = config.title;
  }

  public onSubmit(): void {
    this.updateLastHandledTimestamp();
    const formData = new FormData();
    formData.append('rating', this.rating.toString());
    formData.append('comment', this.comment);
    formData.append('whitelabel', this.appName);

    this.http
      .post('/company/feedbackReview', formData)
      .pipe(first())
      .subscribe(() => {
        this.visible = false;
        localStorage.removeItem(FEEDBACK_REVIEW_SESSION_KEY);
        this.thankYouVisible = true;
      });
  }

  public handleDialogHide(): void {
    this.updateLastHandledTimestamp();
  }

  private shouldShowDialog(): boolean {
    return false; // Temporarily disabled

    const storedValue = localStorage.getItem(FEEDBACK_REVIEW_SESSION_KEY);
    if (!storedValue) {
      return true;
    }

    const lastHandledAt = new Date(storedValue);
    if (Number.isNaN(lastHandledAt.getTime())) {
      return true;
    }

    const nextEligible = new Date(lastHandledAt);
    nextEligible.setMonth(
      nextEligible.getMonth() + this.FEEDBACK_REVIEW_COOLDOWN_MONTHS
    );

    return nextEligible <= new Date();
  }

  private updateLastHandledTimestamp(): void {
    localStorage.setItem(FEEDBACK_REVIEW_SESSION_KEY, new Date().toISOString());
  }
}
